import React, { useState } from "react";

import terraceImg from "../../assets/images/Courtyard/Amenities/Terrace.JPG";

import "../../assets/css/amenities.css"; // Add custom styles
import { Modal } from "react-bootstrap";
import backIcon from "../../assets/images/back_icon.png";
import mapsIcon from "../../assets/images/maps.png";


const CourtyardAmenities = () => {
    const [selectedFloor, setSelectedFloor] = useState("Terrace");
    const [floorImg, setFloorImg] = useState(terraceImg);
    const [iframeUrl, setIframeUrl] = useState("");
    const [showPlan, setShowPlan] = useState(false);


    const skyGardenAmenitiesSpots = [
        { id: 1, name: "Sitting Area", x: "90%", y: "28%", url: "?media=Outdoor Seating" },
        { id: 2, name: "Theater", x: "65%", y: "15%", url: "?media=Cinema Area" },
        { id: 3, name: "Yoga", x: "30%", y: "64%", url: "?media=Yoga" },
        { id: 4, name: "Kids Play Area", x: "55%", y: "65%", url: "?media=Kids Play Area 2" },
        { id: 5, name: "Swimming Pool", x: "75%", y: "40%", url: "?media=Pool View2" },
        { id: 6, name: "Gym", x: "30%", y: "54%", url: "?media=Gym" },
        { id: 7, name: "Calisthenics", x: "15%", y: "44%", url: "?media=Calisthenlcs" },
        { id: 8, name: "Track", x: "35%", y: "24%", url: "?media=Jogging Track" },
        { id: 9, name: "Pet House", x: "30%", y: "32%", url: "?media=Dog House" },
        { id: 10, name: "Golf Putt", x: "52%", y: "15%", url: "?media=Golf Putt" },
        { id: 11, name: "BBQ", x: "59%", y: "12%", url: "?media=Barbecue Area" },
        { id: 12, name: "Reading Area", x: "74%", y: "26%", url: "?media=Reading Area" },
        { id: 13, name: "Jogging Track", x: "23%", y: "36%", url: "?media=Jogging Track" },
        { id: 14, name: "Indoor Games", x: "76%", y: "14%", url: "?media=Outdoor Seating" },
    ];

    const changeFloor = (floorImg, floor) => {
        setSelectedFloor(floor);
        setFloorImg(floorImg);
    }

    return (
        <div className="courtyard amenities-container">
            <div className="scrollable-wrapper">
                <div className={`image-wrapper ${selectedFloor !== "Terrace" && 'Terrace'}`}>
                    <img src={floorImg} alt="Amenities" className="responsive-image" />
                    {skyGardenAmenitiesSpots.map((spot) => (
                        <div
                            key={spot.id}
                            className="spot-label"
                            style={{ left: spot.x, top: spot.y, cursor: "pointer", display: "flex" }}
                            onClick={() => { setIframeUrl(spot.url); setShowPlan(true); }}
                        >
                            <span style={{
                                backgroundImage: `url(${mapsIcon})`, width: "18px", height: "18px", display: "block",
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                            }} className="map_icon"></span>
                            {spot.name}
                        </div>
                    ))}
                </div>
            </div>
            <Modal
                centered
                show={showPlan}
                onHide={() => setShowPlan(false)}
                aria-labelledby="example-custom-modal-styling-title"
                className="courtyard inventory_floor_plan_dialog"
            >
                <Modal.Body>
                    <button className="back_btn" onClick={() => { setShowPlan(false); }}>
                        <img src={backIcon} alt="back icon" className="backIcon" />
                    </button>
                    <iframe src={'https://surbhi-infotech-360.s3.ap-south-1.amazonaws.com/Courtyard_One/index.htm' + iframeUrl} height="100%" width="100%" className="flats_iframe" />
                </Modal.Body>
            </Modal>
        </div >
    );
};

export default CourtyardAmenities;
